/**
 * 🚨 This file is generated by scripts/zendesk.ts. Don't modify it manually!
 */

export const hardshipApplicationCustomFieldsMapAU = {
  Status: { prod: 360013721953, nonProd: "NA" },
  Group: { prod: 360013722013, nonProd: "NA" },
  Assignee: { prod: 360013722033, nonProd: "NA" },
  Channel: { prod: 360004871878, nonProd: "NA" },
  "Applying For Another ": { prod: 360006138498, nonProd: "NA" },
  "Have you been authorised to act on behalf of the account holder?": {
    prod: 360016580098,
    nonProd: "NA",
  },
  "Name of person making application": { prod: 360006179637, nonProd: "NA" },
  "Hardship: Organisation or Financial Counsellor name": {
    prod: 360006159218,
    nonProd: "NA",
  },
  "Customer Email": { prod: 360014741078, nonProd: "NA" },
  "TPA Email Address": { prod: 360008081918, nonProd: "NA" },
  "Hardship: Phone": { prod: 360006160358, nonProd: "NA" },
  "TPA Contact Number": { prod: 360016163237, nonProd: "NA" },
  "Customers first name": { prod: 360006712378, nonProd: "NA" },
  "Surname  (as it appears on ID)": { prod: 360026751773, nonProd: "NA" },
  DOB: { prod: 360022862154, nonProd: "NA" },
  Address: { prod: 360005089238, nonProd: "NA" },
  "Suburb or City": { prod: 360006142138, nonProd: "NA" },
  "Address State": { prod: 360006142438, nonProd: "NA" },
  "Postcode AU/NZ": { prod: 360006163997, nonProd: "NA" },
  "Employment status": { prod: 360007496458, nonProd: "NA" },
  "Offer acceptable, when can you start": { prod: 360006144358, nonProd: "NA" },
  "Hardship Primary reason": { prod: 360006144378, nonProd: "NA" },
  "Hardship Secondary Reason": { prod: 360016649578, nonProd: "NA" },
  "Hardship: Understanding your Situation": {
    prod: 360006047557,
    nonProd: "NA",
  },
  "Were you on hardship assistance for the last 24 months for any Latitude products?":
    { prod: 360016580118, nonProd: "NA" },
  "Hardship Arrangement Term": { prod: 360016580978, nonProd: "NA" },
  Subject: { prod: 360013721913, nonProd: "NA" },
  Description: { prod: 360013721933, nonProd: "NA" },
  "Time spent last update (sec)": { prod: 360021307894, nonProd: "NA" },
  "Total time spent (sec)": { prod: 360021307874, nonProd: "NA" },
  "Hardship DD change consent": { prod: 360006179677, nonProd: "NA" },
  "Terms and Conditions": { prod: 360006024098, nonProd: "NA" },
  "Privacy Acknowledgement": { prod: 360006023478, nonProd: "NA" },
  "shop block": { prod: 360006234458, nonProd: "NA" },
  "Application ID ON FILE": { prod: 360005922518, nonProd: "NA" },
  "Manual Input ON FILE": { prod: 360005796038, nonProd: "NA" },
  "Account Position ON FILE": { prod: 360005807577, nonProd: "NA" },
  "Product Name ON FILE": { prod: 360005938977, nonProd: "NA" },
  "Account number ON FILE": { prod: 360004901638, nonProd: "NA" },
  "Mobile Contact ON FILE": { prod: 360005939037, nonProd: "NA" },
  "Email Contact ON FILE": { prod: 360005939057, nonProd: "NA" },
} as const;

export const hardshipApplicationCustomFieldsMapNZ = {
  Status: { prod: 360013721953, nonProd: "NA" },
  Group: { prod: 360013722013, nonProd: "NA" },
  Assignee: { prod: 360013722033, nonProd: "NA" },
  Channel: { prod: 360004871878, nonProd: "NA" },
  "Applying For Another ": { prod: 360006138498, nonProd: "NA" },
  "Have you been authorised to act on behalf of the account holder?": {
    prod: 360016580098,
    nonProd: "NA",
  },
  "Name of person making application": { prod: 360006179637, nonProd: "NA" },
  "Hardship: Organisation or Financial Counsellor name": {
    prod: 360006159218,
    nonProd: "NA",
  },
  "Customer Email": { prod: 360014741078, nonProd: "NA" },
  "TPA Email Address": { prod: 360008081918, nonProd: "NA" },
  "Hardship: Phone": { prod: 360006160358, nonProd: "NA" },
  "TPA Contact Number": { prod: 360016163237, nonProd: "NA" },
  "Customers first name": { prod: 360006712378, nonProd: "NA" },
  "Surname  (as it appears on ID)": { prod: 360026751773, nonProd: "NA" },
  DOB: { prod: 360022862154, nonProd: "NA" },
  Address: { prod: 360005089238, nonProd: "NA" },
  Suburb: { prod: 360024900637, nonProd: "NA" },
  City: { prod: 360024900657, nonProd: "NA" },
  "Postcode AU/NZ": { prod: 360006163997, nonProd: "NA" },
  "Employment status": { prod: 360007496458, nonProd: "NA" },
  "Offer acceptable, when can you start": { prod: 360006144358, nonProd: "NA" },
  "Hardship Primary reason": { prod: 360006144378, nonProd: "NA" },
  "Hardship Secondary Reason": { prod: 360016649578, nonProd: "NA" },
  "Hardship: Understanding your Situation": {
    prod: 360006047557,
    nonProd: "NA",
  },
  "Were you on hardship assistance for the last 24 months for any Latitude products?":
    { prod: 360016580118, nonProd: "NA" },
  "Hardship Arrangement Term": { prod: 360016580978, nonProd: "NA" },
  Subject: { prod: 360013721913, nonProd: "NA" },
  Description: { prod: 360013721933, nonProd: "NA" },
  "Time spent last update (sec)": { prod: 360021307894, nonProd: "NA" },
  "Total time spent (sec)": { prod: 360021307874, nonProd: "NA" },
  "Hardship DD change consent": { prod: 360006179677, nonProd: "NA" },
  "Terms and Conditions": { prod: 360006024098, nonProd: "NA" },
  "Privacy Acknowledgement": { prod: 360006023478, nonProd: "NA" },
  "shop block": { prod: 360006234458, nonProd: "NA" },
  "Application ID ON FILE": { prod: 360005922518, nonProd: "NA" },
  "Manual Input ON FILE": { prod: 360005796038, nonProd: "NA" },
  "Account Position ON FILE": { prod: 360005807577, nonProd: "NA" },
  "Product Name ON FILE": { prod: 360005938977, nonProd: "NA" },
  "Account number ON FILE": { prod: 360004901638, nonProd: "NA" },
  "Mobile Contact ON FILE": { prod: 360005939037, nonProd: "NA" },
  "Email Contact ON FILE": { prod: 360005939057, nonProd: "NA" },
} as const;

export const applyingForAnotherOptions = [
  {
    id: 360009870558,
    name: "Yes",
    raw_name: "Yes",
    value: "yes_on_behalf",
    default: false,
  },
  {
    id: 360009870578,
    name: "No",
    raw_name: "No",
    value: "no_on_behalf",
    default: false,
  },
] as const;

export const primaryReasonZendeskOptions = [
  {
    id: 1900000156933,
    name: "Bereavement / Loss of loved one",
    raw_name: "Bereavement / Loss of loved one",
    value: "primary_reason_bereavement_/_loss_of_loved_one",
    default: false,
  },
  {
    id: 1900000156953,
    name: "Business Failure",
    raw_name: "Business Failure",
    value: "primary_reason_business_failure",
    default: false,
  },
  {
    id: 1900000156973,
    name: "Carer / Sickness of a loved one",
    raw_name: "Carer / Sickness of a loved one",
    value: "primary_reason_carer_sickness_of_a_loved_one",
    default: false,
  },
  {
    id: 1900000156993,
    name: "Family violence / Financial abuse",
    raw_name: "Family violence / Financial abuse",
    value: "primary_reason_family_violence_financial_abuse",
    default: false,
  },
  {
    id: 1900000157013,
    name: "Financially overcommitted",
    raw_name: "Financially overcommitted",
    value: "primary_reason_financially_overcommitted",
    default: false,
  },
  {
    id: 1900000157033,
    name: "Incarceration",
    raw_name: "Incarceration",
    value: "primary_reason_incarceration",
    default: false,
  },
  {
    id: 1900000157053,
    name: "Maternity",
    raw_name: "Maternity",
    value: "primary_reason_maternity",
    default: false,
  },
  {
    id: 1900000157073,
    name: "Medical condition",
    raw_name: "Medical condition",
    value: "primary_reason_medical_condition",
    default: false,
  },
  {
    id: 1900000157093,
    name: "Natural disaster",
    raw_name: "Natural disaster",
    value: "primary_reason_natural_disaster",
    default: false,
  },
  {
    id: 1900000157113,
    name: "Reduced income",
    raw_name: "Reduced income",
    value: "primary_reason_reduced_income",
    default: false,
  },
  {
    id: 1900000157133,
    name: "Separation / end of a relationship",
    raw_name: "Separation / end of a relationship",
    value: "primary_reason_separation_end_of_a_relationship",
    default: false,
  },
  {
    id: 1900000157153,
    name: "Unemployment",
    raw_name: "Unemployment",
    value: "primary_reason_unemployment",
    default: false,
  },
  {
    id: 1900000157173,
    name: "Other",
    raw_name: "Other",
    value: "primary_reason_other",
    default: false,
  },
] as const;

export const secondaryReasonZendeskOptions = [
  {
    id: 360022730778,
    name: "Bereavement / Loss of loved one",
    raw_name: "Bereavement / Loss of loved one",
    value: "secondary_reason_bereavement_loss_of_loved_one",
    default: false,
  },
  {
    id: 360022730798,
    name: "Business Failure",
    raw_name: "Business Failure",
    value: "secondary_reason_business_failure",
    default: false,
  },
  {
    id: 360022730818,
    name: "Carer / Sickness of a loved one",
    raw_name: "Carer / Sickness of a loved one",
    value: "secondary_reason_carer_sickness_of_a_loved_one",
    default: false,
  },
  {
    id: 360022730838,
    name: "Family violence / Financial abuse",
    raw_name: "Family violence / Financial abuse",
    value: "secondary_reason_family_violence_/_financial_abuse",
    default: false,
  },
  {
    id: 360022730858,
    name: "Financially overcommitted",
    raw_name: "Financially overcommitted",
    value: "secondary_reason_financially_overcommitted",
    default: false,
  },
  {
    id: 360022730878,
    name: "Incarceration",
    raw_name: "Incarceration",
    value: "secondary_reason_incarceration",
    default: false,
  },
  {
    id: 360022730898,
    name: "Maternity",
    raw_name: "Maternity",
    value: "secondary_reason_maternity",
    default: false,
  },
  {
    id: 360022730918,
    name: "Medical condition",
    raw_name: "Medical condition",
    value: "secondary_reason_medical_condition",
    default: false,
  },
  {
    id: 360022730938,
    name: "Natural disaster",
    raw_name: "Natural disaster",
    value: "secondary_reason_natural_disaster",
    default: false,
  },
  {
    id: 360022730958,
    name: "Reduced income",
    raw_name: "Reduced income",
    value: "secondary_reason_reduced_income",
    default: false,
  },
  {
    id: 360022730978,
    name: "Separation / end of a relationship",
    raw_name: "Separation / end of a relationship",
    value: "secondary_reason_separation_/_end_of_a_relationship",
    default: false,
  },
  {
    id: 360022730998,
    name: "Unemployment",
    raw_name: "Unemployment",
    value: "secondary_reason_unemployment",
    default: false,
  },
  {
    id: 360022731018,
    name: "Other",
    raw_name: "Other",
    value: "secondary_reason_other",
    default: false,
  },
] as const;

export const employmentStatusZendeskOptions = [
  {
    id: 360010658938,
    name: "Permanent Employee - Full Time",
    raw_name: "Permanent Employee - Full Time",
    value: "permanent_employee_-_full_time",
    default: false,
  },
  {
    id: 360010658958,
    name: "Permanent Employee - Part Time",
    raw_name: "Permanent Employee - Part Time",
    value: "permanent_employee_-_part_time",
    default: false,
  },
  {
    id: 360010658978,
    name: "Casual/ Temporary",
    raw_name: "Casual/ Temporary",
    value: "casual/_temporary",
    default: false,
  },
  {
    id: 360010658998,
    name: "Contractor",
    raw_name: "Contractor",
    value: "contractor",
    default: false,
  },
  {
    id: 360010659018,
    name: "Self Employed",
    raw_name: "Self Employed",
    value: "self_employed",
    default: false,
  },
  {
    id: 360010659038,
    name: "Workers Compensation",
    raw_name: "Workers Compensation",
    value: "workers_compensation",
    default: false,
  },
  {
    id: 360010659058,
    name: "Pensioner",
    raw_name: "Pensioner",
    value: "pensioner",
    default: false,
  },
  {
    id: 360010659078,
    name: "Unemployed",
    raw_name: "Unemployed",
    value: "unemployed",
    default: false,
  },
] as const;

export const hardshipDurationZendeskOptions = [
  {
    id: 360018701018,
    name: "3 months",
    raw_name: "3 months",
    value: "hardship_arrangement_3_months",
    default: false,
  },
  {
    id: 360018701038,
    name: "6 months",
    raw_name: "6 months",
    value: "hardship_arrangement_6_months",
    default: false,
  },
  {
    id: 360018701058,
    name: "9 months",
    raw_name: "9 months",
    value: "hardship_arrangement_9_months",
    default: false,
  },
  {
    id: 360018701078,
    name: "12 months",
    raw_name: "12 months",
    value: "hardship_arrangement_12_months",
    default: false,
  },
  {
    id: 360018701098,
    name: "More than 12 months",
    raw_name: "More than 12 months",
    value: "hardship_arrangement_more_than_12_months",
    default: false,
  },
] as const;
